import FilterFormContextProvider from 'components/filters/FilterFormContextProvider';
import SectionHeader from 'components/sectionHeader/SectionHeader';
import { useTranslation } from 'react-i18next';
import AutomatedReviewLogsFilters from './filters/AutomatedReviewLogsFilters';
import { AUTOMATED_REVIEW_LOGS_FILTERS_LOCAL_STORAGE_KEY_PREFIX } from './filters/AutomatedReviewLogsFilters.constants';
import {
  automatedReviewLogsFiltersSchema,
  getFormDefaultValues,
} from './filters/AutomatedReviewLogsFilters.schema';
import { AutomatedReviewLogsContainer } from './AutomatedReviewLogs.styles';
import AutomatedReviewLogsTable from './table/AutomatedReviewLogsTable';

const AutomatedReviewLogsSection = () => {
  const { t } = useTranslation();

  return (
    <FilterFormContextProvider
      defaultValues={getFormDefaultValues()}
      localStorageKeyPrefix={
        AUTOMATED_REVIEW_LOGS_FILTERS_LOCAL_STORAGE_KEY_PREFIX
      }
      schema={automatedReviewLogsFiltersSchema()}
    >
      <AutomatedReviewLogsContainer>
        <SectionHeader
          id="automated-review-logs"
          title={t('pageAutomations.reviews.automatedReviewLogs.title')}
          subtitle={t('pageAutomations.reviews.automatedReviewLogs.subtitle')}
        />

        <AutomatedReviewLogsFilters />

        <AutomatedReviewLogsTable />
      </AutomatedReviewLogsContainer>
    </FilterFormContextProvider>
  );
};

export default AutomatedReviewLogsSection;
